import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpWalletQrisDecodeCollectionResponse } from '../../../data/repository/fs-wallet-qris/http-fs-wallet-qris.collection';
import { UseCase } from '../../base/usecase';
import { FSWalletQrisRepository } from '../../repository/fs-wallet-qris.repository';
import { QrisDecodeDTO } from './interface/qris-decode.dto';

@Injectable({
  providedIn: 'root',
})
export class QrisDecodeUsecase
  implements
    UseCase<QrisDecodeDTO, HttpWalletQrisDecodeCollectionResponse>
{
  constructor(private readonly repository: FSWalletQrisRepository) {}

  execute(
    data: QrisDecodeDTO
  ): Observable<HttpWalletQrisDecodeCollectionResponse> {
    return this.repository.QrisDecode(data);
  }
}
